import { render, staticRenderFns } from "./StatisticsByRole.htm?vue&type=template&id=19335a75&scoped=true&"
import script from "./StatisticsByRole.ts?vue&type=script&lang=js&"
export * from "./StatisticsByRole.ts?vue&type=script&lang=js&"
import style0 from "./StatisticsByRole.scss?vue&type=style&index=0&id=19335a75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19335a75",
  null
  
)

export default component.exports